import { Locale, enUS, hu } from 'date-fns/locale';

export const localeMap: Record<string, Locale> = {
  en: enUS,
  hu: hu,
};

export function localeFactory(locale: string): Locale {
  return localeMap[locale] || enUS;
}
